import './utils/vh.utils.js';
import './utils/animate-on-view.utils'
import './utils/parallax-on-view.utills.js'

import './components/header.component.js';
import './components/animations.component.js';
import './components/uploadFile.component.js';
import './components/inputs.component.js';
import './components/double-range.component.js';
import './components/meta-select.component.js';
import './components/job-search.component.js';
import './components/faq.component.js';
import './components/highlights.component.js';

/*Sliders*/
import './components/logos.component.js';
import './components/stats.component.js';
import './components/roles.component.js';
import './components/specialism.component.js';
import './components/credentials.component.js';
import './components/testimonials.component.js';
import './components/swiper-timeline.component.js';
import './components/swiper-team.component.js';
import './components/swiper-benefits.component.js';
import './components/swiper-ts.component.js';
import './components/swiper-areas.component.js';
import './components/swiper-news.component.js';
import './components/areas-tabs-swipers.component.js';
import './components/staffing-swiper.component.js';
import './components/clients.component.js';
/*End Sliders*/

import './libs/countUp.lib.js';


let userAgent = navigator.userAgent.toLowerCase();
let safari15 = /version\/15.*safari/gi.test(userAgent);

if(safari15){
    document.querySelector('body').classList.add('safari-support');
}

